var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVideo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.814,
    height: 16.247,
    viewBox: "0 0 20.814 16.247",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_simple-youtube",
    "data-name": "Icon simple-youtube",
    d: "M20.386,7.933a2.778,2.778,0,0,0-1.811-2.023c-1.622-.485-8.152-.485-8.152-.485s-6.513-.01-8.152.485A2.778,2.778,0,0,0,.46,7.933a33.723,33.723,0,0,0-.453,5.625,33.722,33.722,0,0,0,.453,5.6,2.778,2.778,0,0,0,1.811,2.023c1.621.486,8.152.486,8.152.486s6.512,0,8.152-.486a2.778,2.778,0,0,0,1.811-2.023,33.729,33.729,0,0,0,.434-5.6A33.729,33.729,0,0,0,20.386,7.933Zm-12.047,9.1v-6.97l5.434,3.49Z",
    transform: "translate(-0.007 -5.424)",
    fill: "#d9a45c"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.09ab43b91af6e64414ff3a68524bbe51.svg";
export { ForwardRef as ReactComponent };